import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';
import { Provider } from 'react-redux';
import App from './App';
import './index.css';
import { store } from './Redux/store';
import { TheOfferPage } from './Pages/TheOfferPage';
import { CalcPage } from './Pages/CalcPage';
import { MainPage } from './Pages/MainPage';
import { InfoPage } from './Pages/InfoPage';


export enum Mode {
  ALL_OFFERS = 'allOffers',
  THE_OFFER = 'theOffer',
  MAIN = 'main',
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <Routes>
        <Route element={<App />} >
          <Route index element={<TheOfferPage />} />
          <Route path="calc" element={<CalcPage />} />
        </Route>
        <Route path="main" element={<MainPage />} />
        <Route path="info" element={<InfoPage />} />
      </Routes>
    </Provider>
  </BrowserRouter>
);

